import { forwardRef } from "react";
/**
 * A utility function that creates a forward ref component with polymorphic support,
 * allowing it to accept a variety of props and refs.
 *
 * This function is a type-safe wrapper around `React.forwardRef` with enhanced polymorphism.
 *
 * @example
 * ```typescript
 * // InnerHeading is a component that accepts a polymorphic `as` prop.
 * const Heading = forwardRefPolymorphic(InnerHeading);
 * ```
 */
export const forwardRefPolymorphic = forwardRef;
